import { render, staticRenderFns } from "./OperationChildActions.vue?vue&type=template&id=5310db60&scoped=true"
import script from "./OperationChildActions.vue?vue&type=script&lang=ts"
export * from "./OperationChildActions.vue?vue&type=script&lang=ts"
import style0 from "./OperationChildActions.vue?vue&type=style&index=0&id=5310db60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5310db60",
  null
  
)

export default component.exports